export default __webpack_public_path__ + "static/media/miguel-lopes-25.89a9ad44.jpg";